const PENDING_TOUR_KEY = "sop_app_pending_tour";

export function startTour(roleKey) {
  sessionStorage.setItem(PENDING_TOUR_KEY, roleKey);
}

/** Call once on mount of the page a tour targets. Returns true (and clears
 * the flag) only if that exact tour was just requested from the Help page. */
export function consumePendingTour(roleKey) {
  const pending = sessionStorage.getItem(PENDING_TOUR_KEY);
  if (pending === roleKey) {
    sessionStorage.removeItem(PENDING_TOUR_KEY);
    return true;
  }
  return false;
}
